import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import "rxjs/add/operator/map";
import { LoginQueryModel } from "src/app/components/Shared/Model/login";

@Injectable()
export class LoginService {
  constructor(private http: HttpClient) {}
  clientIDsUsers: any = [];
  //private baseEndPoint: string = "https://idsdatahubdashboardapi.azurewebsites.net/";
  //private datahubBaseEndPoint: string = "https://idsdatahubdashboardapi.azurewebsites.net/";

   private baseEndPoint: string = "https://fxdhdashboardapi.idsnext.live/";
  private datahubBaseEndPoint: string = "https://fxdhdashboardapi.idsnext.live/";
/* private baseEndPoint: string = "https://idsdatahubdashboardapinew.azurewebsites.net/";
  private datahubBaseEndPoint: string = "https://idsdatahubdashboardapinew.azurewebsites.net/";  */
 public isIDSUser(): boolean {
    let Userid = localStorage.getItem("Username").toLowerCase();
    this.clientIDsUsers = ['itcadmin@idsnext.com','itcids@idsnext.com','mitesh@idsnext.com']
    if (this.clientIDsUsers.includes(Userid)) {
      return false;
    }
    else return Userid.includes("@idsnext.com");
    /* else if(Userid.includes("@idsnext.com"))
     return false; */
  }

  public getSearchedHotelSelectedData() {
    return JSON.parse(localStorage.getItem("SearchHotelSelected"));
  }

  login(userId: any, password: any) {
    let data = { userId: userId, password: password };
    let headers = new HttpHeaders({ "Content-Type": "application/json" });

    let endPoint = this.baseEndPoint + "api/login/IsLogin";
    return this.http
      .post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }
  getusername(Userid: any) {
    let data = { Password: Userid };
    let headers = new HttpHeaders({ "Content-Type": "application/json" });

    
    let endPoint = this.baseEndPoint + "api/login/getusername";
    return this.http
      .post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  getcmoverview(Userid: any) {
    let data = { UserId: Userid };
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    let endPoint = this.baseEndPoint + "api/AllCmLog/Overview";
    return this.http
      .post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  getHotelInfoByHotelId(search: any) {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    let endPoint =
      this.datahubBaseEndPoint + "api/hotelsearch/search/" + search;
    return this.http
      .get(endPoint, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  getHeartBeat(search: any) {
    let data = { Password: search };
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    let endPoint = this.baseEndPoint + "api/login/getheartbeat/";
    return this.http
      .post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  getWindowsServiceVersion(search: any) {
    let headers = new HttpHeaders({
      "Content-Type": "text/plain",
      Origin: "https://datahub.idsnext.live",
      Referer: "https://datahub.idsnext.live/",
    });
    let endPoint =
      this.datahubBaseEndPoint +
      "api/hotelsearch/getwindowsserviceversion/winver/" +
      search;
    return this.http
      .get(endPoint, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  getMasterHotelsForIDSUsers(search: any) {
    let data = { password: search };
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    
    let endPoint = this.baseEndPoint + "api/login/getMasterHotelsForIDSUsers";
    return this.http.post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  // Menu Data
  gethotelbyuid() {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    let endPoint = this.baseEndPoint + "api/Menu/GetMenu";
    return this.http.get(endPoint, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }
   // Menu Data_New for particaularUSer
  getMenuforparticularuser(userid:any) {
    let data={userid:userid};
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    let endPoint = this.datahubBaseEndPoint + "/api/Login/ReadDashboardmenu";
    return this.http .post(endPoint,data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }
  getHotelsByUserId(userid: any, search: any) {
    let data = { userid: userid, password: search };
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    
    let endPoint = this.baseEndPoint + "api/login/getHotelsByUserId";
    return this.http
      .post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }

  getproductbyuid(userid: any, check: any) {
    let data = { userid: userid, password: check };
    let headers = new HttpHeaders({ "Content-Type": "application/json" });

    
    let endPoint = this.baseEndPoint + "api/login/gethotelbyUid";
    return this.http
      .post(endPoint, data, { headers: headers })
      .map((response: Response) => JSON.parse(JSON.stringify(response)));
  }
}
